import { hideLoading, showLoading } from 'react-redux-loading-bar';
import externalApi from '../../../utils/externalApi';

const ActionType = {
  RECEIVE_COVER: 'RECEIVE_COVER',
};

function receiveCoverActionCreator(cover) {
  return {
    type: ActionType.RECEIVE_COVER,
    payload: { cover },
  };
}

function asyncReceiveCover() {
  return async (dispatch) => {
    dispatch(showLoading());
    try {
      const cover = await externalApi.getCoverImage();
      dispatch(receiveCoverActionCreator(cover));
    } catch (error) {
      console.log('Failed to load cover image');
    }
    dispatch(hideLoading());
  };
}

export { ActionType, receiveCoverActionCreator, asyncReceiveCover };
